import { PaymentIntent } from 'types';

export interface RecoveryNotice {
  canContinue?: boolean;
  title: string;
  description: string;
}
// Owner 13 Oct: this warning is always bold and in capitals so no one misses it.
export const emphasizeWarnings = (text?: string | null) =>
  (text ?? '').replace(/do not (?:process|charge) the card again(?: or reset the cart)?\.?|do not reset the cart\.?|do not process this payment again\.?/gi,
    match => match.toUpperCase());

export function recoveryGuidance(
  status?: Partial<PaymentIntent>
): RecoveryNotice {
  const reconnect =
    status?.recoveryAction === 'OPEN_CLOVER_APP'
      ? 'On Clover, reopen Cloud Pay Display and tap Start if shown. '
      : '';
  const keepSale = ' DO NOT PROCESS THE CARD AGAIN OR RESET THE CART.';
  if (status?.recoveryAction === 'OWNER_REVIEW')
    return {
      canContinue: false,
      title: 'Payment needs review',
      description:
        'We cannot safely confirm this payment. Keep this sale open and ask the owner to review the original Clover payment.' +
        keepSale,
    };
  if (status?.approvalConfirmed && status.signaturePending) {
    if (status.recoveryStage === 'SIGNATURE_SAVE_PENDING')
      return {
        title: 'Payment approved · Signature not saved yet',
        description:
          'Your signature has been received. Click Credit to finish saving it and continue checkout. The customer does not need to sign again.' +
          keepSale,
      };
    if (status.recoveryStage === 'SIGNATURE_REQUIRED')
      return {
        title: 'Payment approved · Signature needed',
        description:
          reconnect +
          'Click Credit to continue, then ask the customer to follow the signature prompt on Clover.' +
          keepSale,
      };
    return {
      title: 'Payment approved · Signature confirmation pending',
      description:
        reconnect +
        'We haven’t confirmed that the signature was saved. Click Credit to check it and continue checkout. Ask the customer to sign only if Clover requests it.' +
        keepSale,
    };
  }
  return {
    title: 'Payment confirmation pending',
    description:
      reconnect +
      'Make sure Clover and this device are connected to the internet. Then click Credit to check the existing payment and continue checkout.' +
      keepSale,
  };
}
